export default import.meta.ROLLUP_FILE_URL_kD5nLEXj_6xHRRrT3u9Y5w